<template>
  <div class="root">
    <p class="mode">
      <span>金融服务</span>
      <router-link :to="{ name: '金融服务' }">更多></router-link>
    </p>
    <div class="container">
      <!-- <div class="announcement" v-for="(item, index) in list0" :key="index">
        <div style="text-align: center">
          <span style="margin: 0; font-size: 28px" v-html="item.content"></span>
        </div>
        <div style="border-bottom: 1px solid #616161"></div>
        <div class="span">坐落位置: {{ item.address }}</div>
        <div class="span">实际面积: {{ item.areaNum }}</div>
        <div class="span">抵 押 人: {{ item.dyname }}</div>
        <div class="span">登记时间: {{ item.registertime }}</div>
      </div> -->
      <el-table
        header-row-class-name="tableHeader"
        :data="list0"
        style="width: 100%">
        <el-table-column width="400" align="center" prop="cid" label="登记编号">
        </el-table-column>
        <el-table-column
          width="400"
          align="center"
          prop="address"
          label="融资地区">
        </el-table-column>
        <el-table-column
          width="200"
          align="center"
          prop="dyname"
          label="抵押申请人">
        </el-table-column>
        <el-table-column
          width="200"
          align="center"
          prop="type"
          label="抵押物类型">
        </el-table-column>
        <el-table-column
          width="300"
          align="right"
          header-align="center"
          prop="amount"
          label="贷款金额(元)">
          <template slot-scope="scope">
            {{ Number(scope.row.amount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="registertime" label="登记时间">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { financingMsgList } from '@/api/金融服务'
export default {
  data() {
    return {
      list0: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    }
  },
  created() {
    this.getList()
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    getList() {
      financingMsgList(this.queryParams).then((res) => {
        this.list0 = res.data.rows
        this.total = res.total
      })
    },
    // 跳转到交易项目详情
    torongzi(data) {
      this.$router.push({ path: '/financing/detail', query: { id: data.id } })
    },
  },
}
</script>
<style>
.cell {
  font-size: 18px;
}
.tableHeader > th > div {
  font-weight: bold;
  color: #000;
}
.tableHeader > th {
  background-color: rgba(64, 152, 255, 0.2) !important;
}
</style>
<style scoped>
a {
  text-decoration: none;
}
.root {
  min-height: 1180px;
  width: 100%;
  min-height: 585px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  overflow: hidden;
}

.mode {
  display: flex;
  flex-flow: row nowrap;
  /* justify-content: space-between; */
  align-items: center;
  padding: 0 61px 0 37px;
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #2187ff;
  position: relative;
  margin: 0;
  margin: 10px 0;
  margin-bottom: 5px;
}

.container {
  display: flex;
  overflow: hidden;
}

.span {
  margin: 15px 0;
  color: #616161;
}

.announcement {
  width: 21%;
  font-size: 28px;
  padding: 15px;
  padding-top: 0;
  box-shadow: 0px 0px 5px 0px rgba(21, 21, 21, 0.3);
  white-space: nowrap;
  overflow: hidden;
  font-size: 24px;
  margin: 0 20px;
}

.mode > span {
  display: block;
  width: auto;
  height: 50px;
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  padding-left: 5px;
  border-left: #2187ff 6px solid;
  line-height: 50px;
}

.mode > a {
  display: block;
  width: auto;
  height: 80px;
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2187ff;
  line-height: 80px;
  position: absolute;
  right: 7%;
}

.table {
  width: 100%;
}

.first_tr {
  width: 100%;
  height: 75px;
}

.first_tr th {
  height: 75px;

  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 75px;
}

td {
  max-width: 254px;
  height: 51px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 51px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

tr {
  cursor: pointer;
}
</style>
